import React, { useMemo, useState } from "react";
import map from "./jaliscoMap.json";

const ZONES = [
  { id: "norte", idx: "01", name: "Norte" },
  { id: "altos-norte", idx: "02", name: "Altos Norte" },
  { id: "altos-sur", idx: "03", name: "Altos Sur" },
  { id: "cienega", idx: "04", name: "Ciénega" },
  { id: "sureste", idx: "05", name: "Sureste" },
  { id: "sur", idx: "06", name: "Sur" },
  { id: "amula", idx: "07", name: "Sierra de Amula" },
  { id: "costa-sur", idx: "08", name: "Costa Sur" },
  { id: "costa-occ", idx: "09", name: "Costa-Sierra Occidental", reach: "Sucursal Puerto Vallarta" },
  { id: "valles", idx: "10", name: "Valles" },
  { id: "lagunas", idx: "11", name: "Lagunas" },
  { id: "centro", idx: "12", name: "Centro", reach: "Matriz y sucursal Guadalajara" },
];

export default function JaliscoReach() {
  const [activeId, setActiveId] = useState("centro");
  const active = ZONES.find((zone) => zone.id === activeId) || ZONES[11];

  const paths = useMemo(() => {
    const byId = {};
    map.shapes.forEach((shape) => {
      byId[shape.region] = shape.d;
    });
    return byId;
  }, []);

  return (
    <div className="sc-jal">
      <div className="sc-jal-head">
        <p className="sc-mono">Jalisco</p>
        <h3>Hasta dónde llega en el estado.</h3>
        <p>
          Doce regiones. Las sucursales en Jalisco están en Centro y en Costa-Sierra Occidental.
        </p>
      </div>

      <div className="sc-jal-layout">
        <div className="sc-jal-map">
          <svg viewBox={`0 0 ${map.w} ${map.h}`} role="img" aria-label="Regiones de Jalisco">
            {ZONES.map((zone) => (
              <g
                key={zone.id}
                className={[
                  "sc-jal-zone",
                  zone.reach ? "is-reach" : "",
                  zone.id === activeId ? "is-on" : "",
                ].filter(Boolean).join(" ")}
              >
                <path d={paths[zone.id]} onClick={() => setActiveId(zone.id)} />
              </g>
            ))}
          </svg>
          <p key={active.id} className="sc-jal-caption">
            <span>{active.idx}</span>
            <strong>{active.name}</strong>
            <em>{active.reach || "Sin sucursal en esta región. El alcance por ruta se confirma con el equipo."}</em>
          </p>
        </div>

        <div className="sc-zone-list">
          {ZONES.map((zone) => (
            <button
              key={zone.id}
              type="button"
              className={zone.id === activeId ? "sc-zone-btn is-on" : "sc-zone-btn"}
              aria-pressed={zone.id === activeId}
              onClick={() => setActiveId(zone.id)}
            >
              <em>{zone.idx}</em>
              <strong>{zone.name}</strong>
              {zone.reach ? <span className="sc-zone-tag">Sucursal</span> : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
